var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.376,
    height: 23.148,
    viewBox: "0 0 22.376 23.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    transform: "translate(-6.813 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4222",
    "data-name": "Group 4222",
    transform: "translate(6.813 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4221",
    "data-name": "Group 4221",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 5.309,
    height: 2.483,
    transform: "translate(3.754 23.148) rotate(-135)",
    fill: "#efc04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M279.756,52.265a.414.414,0,0,0,.621,0l3.34-3.34a.443.443,0,1,0-.621-.621l-3.34,3.34A.443.443,0,0,0,279.756,52.265Z",
    transform: "translate(-264.194 -45.404)",
    fill: "#efc04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M242.091,4.759a.412.412,0,0,0,.088.034h.148a.443.443,0,0,0,.414-.3L244.219.536a.443.443,0,0,0-.828-.3L241.914,4.2A.414.414,0,0,0,242.091,4.759Z",
    transform: "translate(-228.569 -0.001)",
    fill: "#efc04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M321.068,117.924a.428.428,0,0,0-.6-.354l-3.99,1.478a.414.414,0,0,0-.25.529c0,.011.008.022.013.032a.443.443,0,0,0,.414.3h.148l3.961-1.478A.414.414,0,0,0,321.068,117.924Z",
    transform: "translate(-298.705 -110.886)",
    fill: "#efc04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M54.61,56.757a.6.6,0,0,0-.857.828l1.419,1.389-7.36,11.35,3.9,3.9,1.33-.887,2.69,2.69a.591.591,0,0,0,.414.177.739.739,0,0,0,.414-.177l4.552-4.552a.606.606,0,0,0,0-.857l-1.507-1.507,3.458-2.246,1.389,1.419a.606.606,0,0,0,.857,0,.68.68,0,0,0,0-.857Zm5.232,14.306-3.695,3.695-2.069-2.069,4.493-2.926Z",
    transform: "translate(-45.492 -53.384)",
    fill: "#efc04b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.266c913389c4856d1728e3c67244c908.svg";
export { ForwardRef as ReactComponent };